import React, { Fragment } from 'react';
import DatePicker from 'react-datepicker';
import { Card, Header, Form, Input, Item, Button } from 'semantic-ui-react';

import Field from '../Field';
import AirlineDropdown from '../dropdowns/AirlineDropdown';
import AirportDropdown from '../dropdowns/AirportDropdown';
import TimeInput from '../TimeInput';

const FormView = ({
  errors,
  touched,
  loading,
  onAddFlightOpen,
  onChange,
  onTimeChange,
  onFromDate,
  onToDate,
  onBlur,
  handleSubmit,
  fetchFlightInfo,
  fetchInfoButton,
  values: {
    airline,
    airportDestination,
    airportOrigin,
    flightNo,
    departureTime,
    arrivalTime,
    departureDate,
    arrivalDate
  }
}) => (
  <Fragment>
    <Item>
      <Item.Content>
        <Form loading={loading}>
          <Header as="h4">Add Flight</Header>
          <Card fluid>
            <Card.Content>
              <Form.Group>
                <Field
                  error={errors.airline}
                  touched={touched.airline}
                  width={4}
                >
                  <AirlineDropdown
                    onBlur={onBlur}
                    onChange={onChange}
                    value={airline}
                    labelled
                  />
                </Field>
                <Field
                  error={errors.flightNo}
                  touched={touched.flightNo}
                  width={2}
                >
                  <Form.Field label="Flight number" />
                  <Form.Input
                    style={{ opacity: 1 }}
                    name="flightNo"
                    placeholder="Flight number"
                    value={flightNo}
                    maxLength={5}
                    onChange={onChange}
                    onBlur={onBlur.bind(this, 'flightNo')}
                  />
                </Field>
                <Field
                  error={errors.departureDate}
                  touched={touched.departureDate}
                  width={3}
                >
                  <Form.Field
                    name="departureDate"
                    className="c-DatePicker__wrapper c-DatePicker__wrapper--filters"
                    onBlur={onBlur.bind(this, 'departureDate')}
                  >
                    <label>Departure date</label>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      selected={departureDate}
                      onChange={onFromDate}
                      isClearable
                      showMonthDropdown
                      showYearDropdown
                      customInput={<Input style={{ width: '100%' }} />}
                    />
                  </Form.Field>
                </Field>
                <Field>
                  <label>&nbsp;</label>
                  <Form.Button
                    disabled={!airline || !flightNo || !departureDate}
                    onClick={fetchFlightInfo}
                    {...fetchInfoButton}
                  />
                </Field>
              </Form.Group>
              <Form.Group>
                <Field
                  error={errors.airportOrigin}
                  width={4}
                  touched={touched.airportOrigin}
                >
                  <AirportDropdown
                    name="airportOrigin"
                    label="Airport Origin"
                    placeholder="Airport Origin"
                    value={airportOrigin}
                    onChange={onChange}
                    onBlur={onBlur.bind(this, 'airportOrigin')}
                  />
                </Field>
                <Field
                  error={errors.airportDestination}
                  width={4}
                  touched={touched.airportDestination}
                >
                  <AirportDropdown
                    name="airportDestination"
                    label="Airport Destination"
                    placeholder="Airport Destination"
                    value={airportDestination}
                    onChange={onChange}
                    onBlur={onBlur.bind(this, 'airportDestination')}
                  />
                </Field>

                <Field
                  error={errors.departureTime}
                  touched={touched.departureTime}
                  width={2}
                >
                  <label>Departure Time</label>
                  <TimeInput
                    placeholder="Departure Time"
                    name="departureTime"
                    onTimeChange={onTimeChange}
                    initTime={departureTime}
                  />
                </Field>
                <Field
                  error={errors.arrivalDate}
                  touched={touched.arrivalDate}
                  width={2}
                >
                  <Form.Field
                    name="arrivalDate"
                    className="c-DatePicker__wrapper c-DatePicker__wrapper--filters"
                    onBlur={onBlur.bind(this, 'arrivalDate')}
                  >
                    <label>Arrival date</label>
                    <DatePicker
                      dateFormat="DD/MM/YYYY"
                      selected={arrivalDate}
                      onChange={onToDate}
                      isClearable
                      showMonthDropdown
                      showYearDropdown
                      customInput={<Input style={{ width: '100%' }} />}
                    />
                  </Form.Field>
                </Field>
                <Field
                  error={errors.arrivalTime}
                  touched={touched.arrivalTime}
                  width={2}
                >
                  <label>Arrival Time</label>
                  <TimeInput
                    placeholder="Arrival Time"
                    name="arrivalTime"
                    onTimeChange={onTimeChange}
                    initTime={arrivalTime}
                  />
                </Field>
              </Form.Group>
            </Card.Content>
          </Card>
        </Form>
      </Item.Content>
    </Item>
    <Item>
      <Item.Content>
        <Button
          disabled={loading}
          primary
          size="mini"
          floated="right"
          icon={'save'}
          name="Save"
          labelPosition="left"
          className="c-TicketDetails__add-btn"
          content={'Save'}
          onClick={handleSubmit}
          type="submit"
        />
      </Item.Content>
    </Item>
  </Fragment>
);

export default FormView;



// WEBPACK FOOTER //
// ./src/component/AddFlight/FormView.js